import {SVGProps} from 'react';

const Icon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="24"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M3.5 20.5H20.5M3.5 17.5H5.5M20.5 17.5H18.5M5.5 7.5H4C3.72386 7.5 3.5 7.27614 3.5 7V4.89601C3.5 4.66398 3.65962 4.46244 3.88548 4.4093L11.8855 2.52695C11.9608 2.50922 12.0392 2.50922 12.1145 2.52695L20.1145 4.4093C20.3404 4.46244 20.5 4.66398 20.5 4.89601V7C20.5 7.27614 20.2761 7.5 20 7.5H18.5M5.5 7.5V17.5M5.5 7.5H9.5M5.5 17.5H9.5M18.5 7.5V17.5M18.5 7.5H14.5M18.5 17.5H9.5M9.5 7.5V17.5M9.5 7.5H14.5M14.5 7.5V17"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
        />
    </svg>
);

export default Icon;
